import { useCallback } from 'react'
import { AppRoutesNavigation } from 'src/app-routes'
import { useNavigation } from 'src/context/NavigationContext'
import { useDialogCtx } from 'src/hooks/context-hooks'

export interface DeviationNavigationContext {
  customerId: EntityId
  localityId?: EntityId | null
  serviceStationId?: EntityId | null
  storageId?: EntityId | null
}

export const useNavigateToDeviation = () => {
  const { navigateTo } = useNavigation()
  const { closeAllDialogs } = useDialogCtx()

  return useCallback(
    (deviationId: EntityId, context: DeviationNavigationContext) => {
      const { customerId, localityId, serviceStationId, storageId } = context
      closeAllDialogs()

      if (localityId)
        navigateTo(AppRoutesNavigation.Localities.deviation(customerId, localityId as EntityId, deviationId))
      else if (serviceStationId)
        navigateTo(AppRoutesNavigation.serviceStation.deviation(customerId, serviceStationId as EntityId, deviationId))
      else if (storageId)
        navigateTo(AppRoutesNavigation.storage.deviation(customerId, storageId as EntityId, deviationId))
      else navigateTo(AppRoutesNavigation.Customer.deviation(customerId, deviationId))
    },
    [navigateTo, closeAllDialogs],
  )
}
